<template>
    <div class="callUs">
        <div class="callBox">
            <div class="callTitle">联系我们</div>
            <div class="callInfo">
                <div class="leftBox">
                    <div class="infoBox">
                        <div class="phoneBox">
                            <div class="tle">
                                <img src="../../assets/image/common/phoneIco.png" alt="" />
                                <span>联系电话</span>
                            </div>
                            <div class="number">
                                <span>18224014957</span>
                                <span style="font-size: 14px; font-weight: normal">(唐女士)</span>
                            </div>
                        </div>
                        <div class="addressBox">
                            <div class="tle">
                                <img src="../../assets/image/common/addressIco.png" alt="" />
                                <span>联系地址</span>
                            </div>
                            <div class="number">成都市金牛区大成仓·智汇园A205</div>
                        </div>
                    </div>
                    <div class="qrcodeBox">
                        <img src="../../assets/image/common/qrcodeWx.png" alt="" />
                        <span>扫码添加企业微信</span>
                    </div>
                </div>
                <div class="lineBox"></div>
                <div class="rightBox">
                    <div class="title">留下您的联系方式</div>
                    <div class="formBox">
                        <input type="text" v-model="subForm.contact_user" placeholder="您的姓名" class="formInput" />
                        <input type="text" v-model="subForm.contact_tel" placeholder="电话" class="formInput" />
                        <input type="text" v-model="subForm.address" placeholder="公司名称" class="formInput" />
                        <button class="formBtn" v-wave @click="getOurList">提交信息</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getOurList } from '@/api/api';
export default {
    data() {
        return {
            subForm: {
                contact_user: '',
                contact_tel: '',
                address: '',
            },
        };
    },
    methods: {
        async getOurList() {
            let data1 = {
                ...this.subForm,
            };
            let result = await getOurList(data1);
            console.log(result);
            this.$message.success('提交成功');
        },
    },
};
</script>

<style lang="scss" scoped>
.callUs {
    width: 100%;
    background: url(@/assets/image/common/usBg.png) no-repeat center;
    background-size: 100% 100%;
    padding: 40px 0 0 0px;
    height: 450px;
    box-sizing: border-box;

    .callBox {
        width: 1200px;
        height: 370px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 0 75px;
        box-shadow: linear-gradient(92deg, #f7fbff 0%, #fdfeff 42%, #e4f1ff 100%);
        background: url(@/assets/image/common/minUs.png) no-repeat center;
        background-size: 100% 100%;
        border-radius: 10px;
        background-color: #fff;

        .callTitle {
            font-size: 34px;
            color: #1a1a1a;
            text-align: center;
            padding: 40px 0;
            font-weight: bold;
        }
    }
    .callInfo {
        display: flex;
        align-items: center;
        gap: 75px;
        .leftBox {
            width: 450px;
            height: 185px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .infoBox {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 48px;
                .phoneBox {
                    .tle {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    .number {
                        margin-top: 11px;
                        font-weight: bold;
                        font-size: 24px;
                        color: #1a1a1a;
                    }
                }
                .addressBox {
                    .tle {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                    .number {
                        margin-top: 11px;
                        font-size: 14px;
                        color: #1a1a1a;
                        color: #1a1a1a;
                    }
                }
            }
            .qrcodeBox {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 11px;
                font-size: 14px;
                color: #1a1a1a;
                img {
                    width: 135px;
                    height: 135px;
                }
            }
        }
        .lineBox {
            width: 1px;
            height: 185px;
            background-color: #cdd6db;
        }
        .rightBox {
            width: 450px;
            height: 185px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 22px;
            .title {
                margin-top: 7px;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
            }
            .formBox {
                width: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .formInput {
                    width: 216px;
                    height: 48px;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #dbe1e5;
                    padding: 0px 9px;
                    box-sizing: border-box;
                    font-size: 16px;
                    margin-bottom: 20px;
                    color: #1472ff;
                    &::placeholder {
                        color: #333333;
                    }
                    &:focus {
                        outline: 1px solid #1472ff;
                        color: #1472ff;
                        &::placeholder {
                            color: #1472ff;
                        }
                    }
                }
                .formBtn {
                    border: none;
                    width: 216px;
                    height: 48px;
                    background: #1472ff;
                    border-radius: 4px 4px 4px 4px;
                    color: #fff;
                    font-size: 16px;
                    cursor: pointer;
                    &:hover {
                        background: #4d94ff;
                    }
                }
            }
        }
    }
}
</style>
